module.exports = __webpack_public_path__ + "img/pic25.683c1ff1.jpg";